/**
 * What: Merchant-facing copy dictionary for Shopify credit activity statement and plan billing.
 * Transport / data-flow: Exported by product-language for consumption by apps/shopify components.
 *
 * "Credit" is the merchant-facing unit of measurement spent by every metered action in the app
 * (test runs, copilot suggestions, store-intelligence lookups, etc.), each at its own credit cost.
 * "Test" names one specific action a merchant takes — it is never a quantity or unit.
 */
export const shopifyComponentUsageCreditsCopy = {
    usageCurrency: {
        unitSingular: 'Credit',
        unitPlural: 'Credits',
        activityLogTitle: 'Credit activity',
        failedTestCreditsReturned: 'Credits returned — test failed',
        failedTestCreditsPending: 'Credit return pending',
        failedTestCreditReason: 'The test failed before results could be delivered.',
        activityTableHeaderDate: 'Date',
        activityTableHeaderActivity: 'Activity',
        activityTableHeaderAmount: 'Credits',
        activityTableHeaderBalance: 'Balance after',
        operationLabels: {
            'study.run': 'Test run',
            'shopify.study_builder.variation_angles': 'Copilot: suggested versions',
            'shopify.study_builder.diagnostic_questions': 'Copilot: suggested questions',
            'shopify.store_intelligence.description_claims': 'Claim ideas from your product page',
        },
        allowanceKindLabels: {
            allowance: 'Monthly plan allowance',
            grant: 'Credits added',
            charge: 'Credit used',
            refund: 'Credit returned',
            pending: 'Credit reserved',
        },
        emptyActivityMessage: 'No credit activity recorded yet.',
        notConnectedActivityBody: 'Credit activity will appear here once your store is connected to TestFeed.',
        loadActivityErrorMessage: "We couldn't load your credit activity. Please try again.",
        nextPageButton: 'Next page',
        previousPageButton: 'Previous page',
    },
    planBilling: {
        subscribeButton: 'Choose a plan',
        planRequiredStudyBody: 'Choose a TestFeed plan to run this test. Your test is saved and ready when you subscribe.',
        planRequiredAssistBody: 'Choose a TestFeed plan to use AI assists. Your work is saved.',
        planHandleUnknownBody: "TestFeed doesn't recognise this Shopify plan yet. Your subscription is unchanged — try again shortly or contact TestFeed support.",
        planChangedBody: 'Your TestFeed plan has changed. Your credits reset at the start of each month.',
        limitReachedBody: "You don't have enough credits left this month for this. Upgrade your plan to keep testing, or wait for your credits to reset.",
        limitReachedTitle: 'Not enough credits',
        limitReachedDetail: 'This test needs {quoted} credits · {available} available.',
        limitResetDate: 'Credits reset on {date}.',
        planCancelledBody: 'Your TestFeed subscription has ended. Choose a plan to keep running tests — your past results stay available.',
    },
};
//# sourceMappingURL=usage-credits.js.map